module.exports = __webpack_public_path__ + "static/media/poster_embed.2499fa6c.png";